import React from "react"
import { storyblokEditable } from "@storyblok/react"

import Markdown from "react-markdown"
import remarkSubSuper from "remark-sub-super"
import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"

import { ContentpageTwoColumn, transformLinkUri } from "gatsby-theme-gba"

const ContentpageTwoColumnEditable = ({ blok }) => {
  const { file, allFile } = useStaticQuery(graphql`
    query ContentPageTwoColumnExampleQuery {
      file(relativePath: { eq: "contentpage-two-column.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      allFile(filter: { id: { regex: "/(?:.*)contentpageTwoColumn/" } }) {
        edges {
          node {
            id
            name
            childImageSharp {
              gatsbyImageData(
                width: 791
                quality: 80
                breakpoints: [198, 396, 616, 791]
              )
            }
          }
        }
      }
    }
  `)

  let filteredFiles = allFile.edges.filter(function (projectFile) {
    if (!blok.image || !projectFile.node.id.includes(blok.image.substring(1))) {
      return false // skip
    }

    return true
  })

  let imageFile = filteredFiles[0]
    ? getImage(filteredFiles[0].node)
    : "https:" + blok.image

  let link = blok.link.cached_url

  if (blok.link.linktype === "story") {
    link = blok.link.id
  }
  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  }

  const replaceAll = (str, term, replacement) =>
    str.replace(new RegExp(escapeRegExp(term), "g"), replacement)

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <ContentpageTwoColumn
        heading={blok.heading || "Headline"}
        headlineName={blok.headlineName}
        disableHyphens={blok.disableHyphens}
        image={imageFile || getImage(file)}
        imageAlt={blok.imageAlt}
        link={link}
        linkText={blok.linkText}
        linkTarget={blok.linkTarget}
        mode={blok.mode}
        reverse={blok.reverse}
        currentLanguage={blok.currentLanguage}
        imagePaddingTop={blok.imagePaddingTop}
        headingTop={blok.headingTop}
        inMiddle={blok.inMiddle}
        isBlogChild={blok.is_blog_child}
        date={blok.sort_by_date}
      >
        <Markdown
          plugins={[remarkSubSuper]}
          renderers={{
            sub: "sub",
            sup: "sup",
          }}
          transformLinkUri={(uri) => {
            return transformLinkUri(uri, "", blok.currentLanguage)
          }}
        >
          {replaceAll(blok.body, "\u2028", "")}
        </Markdown>
      </ContentpageTwoColumn>
    </div>
  )
}

export default ContentpageTwoColumnEditable
